import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import AuthMixin from '@/helpers/vue_mixins/v2/AuthMixin';
import AesMixin from '@/helpers/vue_mixins/v2/AesMixin';
import FbLoginButton from '@/components/auth/FbLoginButton.vue';
import LoginWrapper from '@/components/v2/LoginWrapper.vue';
import StoreManagerSignIn from '@/plugins/graphql/mutations/v2/store-manager-signin.gql';
import { UserType } from '@/helpers/entities/enums/UserType';
import { resetStore } from '@/plugins/vue-apollo';
import { OVERVIEW_ROUTE } from '@/helpers/constants/StoreManagerRoutes';
import { STORE_MANAGEMENT } from '@/helpers/constants/CustomBundleKeys';
import UserPilotMixin from '@/helpers/vue_mixins/v2/UserpilotMixin';
import me from '@/plugins/graphql/queries/me.gql';
let Signup = class Signup extends Mixins(AuthMixin, AlertMixin, AesMixin, UserPilotMixin) {
    get caption() {
        return 'Sign In with Facebook to manage your Store';
    }
    get storeManager() {
        return UserType.StoreManager;
    }
    signIn(token) {
        this.$apollo
            .mutate({
            mutation: StoreManagerSignIn,
            variables: {
                input: {
                    token: this.encrypt(token),
                },
            },
        })
            .then((result) => {
            const data = result.data.storeManagerSignin;
            this.authenticate(data.jwt, this.storeManager);
            const { app } = data;
            this.$apollo
                .query({
                query: me,
            })
                .then((meQuery) => {
                const profile = meQuery.data.me;
                this.userpilotIdentify(profile.id, {
                    name: `${profile.firstName} ${profile.lastName}`,
                    email: profile.email,
                    role: profile.role,
                });
                this.userpilotTrack('User Logged In', {
                    name: `${profile.firstName} ${profile.lastName}`,
                });
            });
            resetStore().then(() => {
                this.$store.commit('navigation_drawer/toggleDrawer');
                this.$router.push({
                    name: OVERVIEW_ROUTE.name,
                    params: {
                        key: STORE_MANAGEMENT,
                        appUUID: app.uuid,
                    },
                });
            });
            this.resetClient(data.jwt);
        })
            .catch((e) => {
            this.errorNotification(e.message);
        });
    }
};
Signup = __decorate([
    Component({
        components: {
            FbLoginButton,
            LoginWrapper,
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.$store.state.displayHomeNav = false;
                return true;
            });
        },
    })
], Signup);
export default Signup;
